import { render, staticRenderFns } from "./officialChoose.vue?vue&type=template&id=7da746ec&scoped=true"
import script from "./officialChoose.vue?vue&type=script&lang=js"
export * from "./officialChoose.vue?vue&type=script&lang=js"
import style0 from "./officialChoose.vue?vue&type=style&index=0&id=7da746ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da746ec",
  null
  
)

export default component.exports